import React from 'react'
import { Contact, Hero, Projects, Skills, TechStack } from '../../components'
import './home.css'

const Home = () => {
  return (
    <>
      <div className='main-content-wrapper'>
        <Hero />
        <Skills />
        <TechStack />
        <Projects />
        <Contact />
      </div>
    </>
  )
}

export default Home